// Generated by CoffeeScript 2.7.0
var DateTimeMixin;

export default DateTimeMixin = {
  computed: {
    formatedValue: function() {
      if (this.value) {
        return this.value.strftime(this.format);
      } else {
        return '';
      }
    },
    viewType: function() {
      if (this.field.settings.input_type === 'time') {
        return 'time';
      } else {
        return 'date';
      }
    },
    format: function() {
      switch (this.field.settings.input_type) {
        case 'time':
          return 'hh:mm';
        case 'date':
          return 'YYYY-MM-DD';
        default:
          return 'YYYY-MM-DD hh:mm';
      }
    },
    viewChangable: function() {
      return this.field.settings.input_type === 'datetime-local';
    },
    valueForCalculation: function() {
      return {
        type: 'Text',
        value: this.formatedValue
      };
    }
  },
  methods: {
    _parseValueToEntries: function() {
      var _result, result;
      _result = [];
      if (this.value) {
        if (this.entries.length) {
          result = _.clone(this.entries[0]);
          result._destroy = false;
          result.value = this.value.strftime(this.format);
        } else {
          result = {
            value: this.value.strftime(this.format),
            field_id: this.field.id
          };
        }
      } else {
        if (this.entries.length && this.entries[0].id) {
          result = _.clone(this.entries[0]);
          result._destroy = true;
        }
      }
      if (result) {
        _result.push(result);
      }
      return _result;
    },
    _initDefaultEntries: function(entries) {
      return entries[0] || {};
    },
    _parseEntriesToValue: function(entry) {
      if (entry.value) {
        return this.value = Date.parseFromString(entry.value);
      } else {
        return this.value = null;
      }
    }
  }
};
